window.slate = window.slate || {};
window.theme = window.theme || {};

// THEME GLOBAL VARS
$.extend(theme, {
  classes: {
    noScroll: 'no-scroll',
    unavailable: 'is-unavailable',
    soldOut: 'is-sold-out',
    waitlist: 'is-waitlist',
    loading: 'is-loading',
    processing: 'is-processing',
    active: 'is-active',
    playing: 'is-playing'
  }
});

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Modules ================*/
// TOGGLER
// Purpose: Toggle state on/off

theme.toggler = (function(){

  var init = function() {
    var $triggers = $('[data-toggler-trigger]');
    if (!$triggers.length) { return; } // quit if not needed

    console.log('toggler.init');

    // VARS
    var self = this;

    // ON CLICK
    $triggers.on('click', function(e) {
      var $trigger = $(this),
          targetID,
          $target,
          activeClass = $trigger.attr('data-toggler-class') || theme.classes.active,
          focusID = $trigger.attr('data-toggler-focus'),
          $focusTarget = $('#'+focusID);

      // decide mode
      if ($trigger.attr('data-toggler-trigger') !== '') {

        // use target/trigger values
        targetID = $trigger.attr('data-toggler-trigger');
        $target = $(targetID); // try to find via ID

        // if can't find, try via toggler target
        if ($target.length === 0) { $target = $('[data-toggler-target="'+targetID+'"]'); }

      } else if ($trigger.attr('href')) {

        // use href/id
        targetID = $trigger.attr('href');
        $target = $(targetID);

      } else {

        // use closest
        $target = $trigger.closest('[data-toggler-target]');

      };

      e.preventDefault();

      console.log("target: " + $target);

      if ($target.hasClass(activeClass)) {
        $target.removeClass(activeClass);
        $focusTarget.blur();
      } else {
        $target.addClass(activeClass);
        $focusTarget.focus();
      }
    });

  };

  return {
    init: init
  }
})();

// SMOOTH SCROLL
// Purpose: Smoothly scroll to an in-page anchor

theme.smoothScroll = (function () {

  var init = function() {
    var $triggers = $('[data-smooth-scroll]');
    if (!$triggers.length) { return; } // quit if not needed

    console.log('smoothScroll.init');

    // // VARS
    var self = this;

    // ACTION
    $triggers.on('click', function(e) {
      e.preventDefault();

      var $trigger = $(this),
          targetID = $trigger.attr('href'),
          $target = $(targetID),
          triggerOffset = parseInt($trigger.attr('data-smooth-scroll-offset') || 0);

      if ($target.length) {
        $('html, body').animate({
          scrollTop: ($target.offset().top - triggerOffset)
        }, 600, 'swing', function () {
          // window.location.hash = targetID; *REMOVED TO STOP BROWSER JUMPING PAST THE HEADER.*
        });
      }

    });

  };

  return {
    init: init
  }

})();

//In Vision

theme.inView = (function(){

  var init = function() {

    var $element = $('[data-in-view]');
    if (!$element.length) { return; } // quit if not needed
    console.log('inView.init');

    //Fully in vision
    $.fn.isFullyInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementTop >= viewportTop && elementBottom <= viewportBottom;
    };

    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    var timer;
    $(window).scroll(function() { //Throttling

      if(timer) {
          window.clearTimeout(timer);
      }
      timer = window.setTimeout(function() {

        //Check if in viewport
        $('[data-in-view]').each(function() {
          if ($(this).isInViewport()) {
            $(this).addClass('in-view');
          } else {
            $(this).removeClass('in-view');
          }
        });

        //Check if fully in viewport
        $('[data-fully-in-view]').each(function() {
          if ($(this).isFullyInViewport()) {
            $(this).addClass('in-view');
          } else {
            $(this).removeClass('in-view');
          }
        });

        //Change state of main logo on scroll
        if($(window).scrollTop() > 0) {
          $("[data-at-top]").removeClass('at-top');
        } else {
          $("[data-at-top]").addClass('at-top');
        }
      }, 20);
    });
  };

  return {
    init: init
  }
})();

//Slick Slider: http://kenwheeler.github.io/slick/

theme.carousel = (function(){
  var init = function() {

    var $activate = $('[data-carousel-activate]');
    if (!$activate.length) { return; }; // quit if not needed

    console.log('carousel.init');

    //MAIN CAROUSEL
    $('[data-carousel]').slick({
      infinite: true,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      asNavFor: '.product__carousel__thumbnails',
      prevArrow: '<button type="button" class="product-carousel__arrow product-carousel__arrow--prev slick-arrow slick-disabled" aria-disabled="true" style="display: block;"><svg class="icon icon--wide icon-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126.79 71.17"><title>Arrow</title><path d="M622,343l61.64,64.32c2.37-2.75,4.28-5.2,6.42-7.43q25.4-26.55,50.85-53c1.14-1.19,2.07-2.57,3.09-3.86h1c3.36,7.46,2,14.05-4,19.5-18.26,16.78-36.64,33.45-54.92,50.21-2,1.8-3.46,2-5.51.16q-27.26-25-54.62-49.8c-6.17-5.61-7-12.46-5-20.07Z" transform="translate(-620 -343)"/></svg><span class="visually-hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="product-carousel__arrow product-carousel__arrow--next slick-arrow" aria-disabled="false" style="display: block;"><svg class="icon icon--wide icon-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126.79 71.17"><title>Arrow</title><path d="M622,343l61.64,64.32c2.37-2.75,4.28-5.2,6.42-7.43q25.4-26.55,50.85-53c1.14-1.19,2.07-2.57,3.09-3.86h1c3.36,7.46,2,14.05-4,19.5-18.26,16.78-36.64,33.45-54.92,50.21-2,1.8-3.46,2-5.51.16q-27.26-25-54.62-49.8c-6.17-5.61-7-12.46-5-20.07Z" transform="translate(-620 -343)"/></svg><span class="visually-hidden">Next</span></button>'
    });

    var slickOptions = {
      slidesToShow: 100,
      slidesToScroll: 1,
      asNavFor: '[data-carousel]',
      dots: false,
      focusOnSelect: true
    };

    $('[data-carousel-thumbnails]').slick(slickOptions);

    $(window).on('resize orientationchange', function() {
        $('[data-carousel-thumbnails]').slick('unslick');
        $('[data-carousel-thumbnails]').slick(slickOptions);
    });

    //HOMEPAGE CAROUSEL
    $('[data-carousel-hero]').slick({
      infinite: true,
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3500,
      fade: true,
      speed: 1700
    });

    // COLLECTION CAROUSEL
    $('[data-carousel-collection]').slick({
      mobileFirst: true,
      dots: true,
      dotsClass: 'slick-paged-dots',
      arrows: false,
      lazyLoad: 'ondemand',
      rows: 2,
      slidesPerRow: 2,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            rows: 2,
            slidesPerRow: 4,
          }
        }
      ]
    }).on('lazyLoaded', function(event, slick, image, imageSource){
      $(image).addClass('lazyloaded');
    });

  };

  return {
    init: init
  }
})();

theme.engraving = (function(){
  var init = function() {

    var $engraving = $('[data-engraving]');
    if (!$engraving.length) { return; }; // quit if not needed

    console.log('engraving.init');

    // VARS
    var $engravingStyleField = $engraving.find('[data-engraving-style]'),
        $engravingTextField = $engraving.find('[data-engraving-text]'),
        $engravingQtyField = $engraving.find('[data-engraving-qty]'),
        $engravingCostElement = $engraving.find('[data-engraving-cost]'),
        $engravingUI = $engraving.find('[data-engraving-ui]'),
        $productForm = $engraving.parents('form[action="/cart/add"]'),
        $productFormSubmitters = $productForm.find('[type="submit"]'),
        $engravingCartProductQty = $engraving.find('[data-engraving-cart-product-qty]'),
        engravingStylePrice,
        engravingQty,
        engravingCost,
        engravingCostFormatted;

    // Calculate cost of engraving based on character count and engraving style price
    function calculateCost() {
      engravingStylePrice = $engravingStyleField.find('option:selected').attr('data-engraving-style-price') || 0;
      engravingQty = $engravingQtyField.val();
      engravingCost = engravingStylePrice * engravingQty;
      engravingCostFormatted = slate.Currency.formatMoney(engravingCost, theme.moneyFormat);
      $engravingCostElement.text(engravingCostFormatted);
    };

    // when we change text, calculate costs
    $engravingTextField.on('input', function() {
      var characterCount = $engravingTextField.val().replace(/\s+/g, '').length;
      $engravingQtyField.val(characterCount);
      calculateCost();
    });

    // when we change style, hide/show UI and calculate costs
    $engravingStyleField.on('change', function() {

      if ($engravingStyleField.find('option:selected').is('[data-engraving-none]')) {

        $engravingUI.hide();

      } else {

        $engravingUI.show();
        calculateCost();
      }
    }).trigger('change'); // (trigger change so this behaviour runs on load)

    // when we submit form, AJAX add product, then AJAX add engraving... forward to cart
    $productForm.on('submit', function(event) {

      // unless no engraving chosen
      if (!$engravingStyleField.find('option:selected').is('[data-engraving-none]')) {
        event.preventDefault();

        var $form = $(this),
            formData = $form.serializeArray(),
            formJSON = {};

        $productFormSubmitters.prop('disabled',true); // disable form submissions while we work

        // JSON tha' data
        $.each(formData, function(i, v) {
          formJSON[v.name] = v.value;
        });

        // Main product AJAX
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: formJSON,
          dataType: 'json'
        }).done(function(itemData) { // if successful
          console.log('Product added to cart',itemData);

          // Engraving product AJAX
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id: $engravingStyleField.find('option:selected').attr('data-engraving-style-price-id'),
              quantity: $engravingQtyField.val() * itemData.quantity,
              properties: {
                'For': itemData.product_title,
                '_engraving_text': $engravingTextField.val(),
                '_engraving_product_key': itemData.key
              }
            },
            dataType: 'json'
          }).done(function(itemData) { // if successful
            console.log('Engraving added to cart',itemData);

            window.location.href = '/cart'; // go to cart as normal

          }).fail(function(xhr,textStatus) { // if fail
            console.log('Failed to add engraving to cart',textStatus,xhr);
            alert('Problem adding product - please try again, or contact us');
            $productFormSubmitters.prop('disabled',false); // resume
          });

        }).fail(function(xhr,textStatus) { // if fail
          console.log('Failed to add to cart',textStatus,xhr);
          alert('Problem adding product - please try again, or contact us');
          $productFormSubmitters.prop('disabled',false); // resume
        });
      }

    });

    // CART: when we change cart product quantity, multiple and update engraving quantity
    $engravingCartProductQty.on('change', function() {
      var productQty = $(this).val(),
          $currentEngravingCartQty = $(this).closest('[data-engraving]').find('[data-engraving-cart-qty]'),
          characterCountPerProduct = $currentEngravingCartQty.attr('data-engraving-cart-qty'),
          newCharacterCount = productQty*characterCountPerProduct;

      $currentEngravingCartQty.val(newCharacterCount);
    });

  };

  return {
    init: init
  }
})();


$(document).ready(function() {

  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  //Sticky Nav
  var stickyElement = $('[data-sticky]'),
      height = stickyElement.outerHeight(),
      offset = $('[data-sticky-offset]').outerHeight(),
      mainContent = $('[data-has-sticky]');

  $(window).scroll(function() {
    if ($(window).scrollTop() > offset) {
      stickyElement.addClass('is-stuck');
      mainContent.css('margin-top', height);
    } else {
      stickyElement.removeClass('is-stuck');
      mainContent.css('margin-top', '0');
    }
  });

  //Custom Number Input
  $('.quantity').each(function() {
    var spinner = jQuery(this),
      input = spinner.find('input[type="number"]'),
      btnUp = spinner.find('.quantity-up'),
      btnDown = spinner.find('.quantity-down'),
      min = input.attr('min'),
      max = input.attr('max');

    btnUp.click(function() {
      var oldValue = parseFloat(input.val());
      if (oldValue >= max) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue + 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });

    btnDown.click(function() {
      var oldValue = parseFloat(input.val());
      if (oldValue <= min) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue - 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });

  });

  //Form redirect to previous page
  var url = window.location.pathname;
  $("#redirect_url").val(url);

  // INIT
  theme.toggler.init();
  theme.smoothScroll.init();
  theme.inView.init();
  theme.carousel.init();
  theme.engraving.init();

});
